/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  COPPA_DESCRIPTIONS,
  COPPA_TARGET_CHILDREN_ICONS,
  COPPA_TARGET_CHILDREN_LABELS
} from 'app/constants/COPPA_PERMISSIONS';
import { User } from 'app/models/User';
import {
  MediaQueryService,
  Breakpoint
} from 'app/services/media-query.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'ctv-coppa-permissions',
  templateUrl: './ctv-coppa-permissions.html',
  styleUrls: ['./ctv-coppa-permissions.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtvCoppaPermissions {
  Breakpoint = Breakpoint;

  @Input() domain;
  @Input() region;
  @Input() device;
  @Input() data;
  @Input() month;
  @Input() isFreemium: boolean;
  @Output() anchorClick = new EventEmitter<string>();

  showDangerous = true;

  descriptions = COPPA_DESCRIPTIONS;

  bp$: Observable<Breakpoint>;

  get targetChildrenActiveLabel() {
    return COPPA_TARGET_CHILDREN_LABELS[
      this.data?.coppaPermissions?.targetChildrenRisk || 'na'
    ];
  }

  get targetChildrenActiveIcon() {
    return COPPA_TARGET_CHILDREN_ICONS[
      this.data?.coppaPermissions?.targetChildrenRisk || 'na'
    ];
  }

  get targetChildrenReason() {
    const reasons = this.data?.coppaPermissions?.targetChildrenRiskReason;
    if (reasons && reasons[0]) return reasons[0];
    return this.targetChildrenActiveLabel;
  }

  constructor(_media: MediaQueryService, public user: User) {
    this.bp$ = _media.activeBreakpoint$;
  }

  goToSection(anchor: string) {
    this.anchorClick.emit(anchor);
  }
}
